import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { header } from "./header";
import { channelsList_template } from "../components/templates/channelsList_template";

declare var ko: any;
declare var page: any;

export class channels extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected template: channelsList_template;
    protected pagination: pagination_template;

    protected getModuleName(){

        return "channels";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.template = new channelsList_template("list", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Channel");

        return [this.template.build()];
    }
    public fillPage() : void{

        this.getReferences();
    }

    protected getReferences() {

        // LOADING : starts
        //this.template.activateLoading();

        let usrReq_url: string = `/api/brand/${this.getBrandID()}/channels/references`;
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['getReferences'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getReferences'].onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdls['getReferences'].execute();
    }

    public onReferencesRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.template.setIsAvailableForUseFilter(responseParsed.isAvailableForUse);

                //set filters
                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();

                // LOADING : ends
                //obj.template.deactivateLoading();
            })
        }
    }

    // preset filter methods
    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.template.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onSaveSearchPresetReturn;
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onSaveSearchPresetReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.template.addCreatedPresetToList(response);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onSaveFavoriteSearchPresetReturn
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onSaveFavoriteSearchPresetReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = `/api/search_preset/delete/{presetId}/`;
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
            });
        }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            // @ts-ignore
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.template.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.template.setSearchPresets(response);
                obj.filterList();
            });
        }
    }


    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.template.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = `/api/brand/${this.getBrandID()}/channels/get/`;
        let subViewModel = this.template.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'get-list-elements');
        this.updateViewModelFromPath(); //to set selected filters
    }

    protected paginationOnPageClick(){
        this.filterList();
    }

    protected filterDropdownOnChange(idElement){

        switch(idElement){
            default:
                this.viewModel.list.pagination.pageNumber(1);
                this.filterList();
        }

    }

    protected filterSimpleOnChange(idElement){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.paginatedResults, req.requestStartTime);
            });
            obj.loadingOut(obj.template.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(paginatedResults: any, requestStartTime){
        this.template.setChannelList(paginatedResults.data);

        const execTime = Math.round((new Date().getTime() - requestStartTime) / 1000 * 100) / 100;
        this.template.setResultInfo(paginatedResults.totalCount, paginatedResults.totalPage, execTime);

        // update the paginator
        this.viewModel.list.pagination.itemCount(paginatedResults.totalCount);
    }

    protected setDefaultStatusFilters() {
    }

    protected getBrandID(): number {
        return this.getVnAppZone().getApp().params.idBrand;
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.template.getTemplateViewModel();

        delete templateViewModel.channels;

        return templateViewModel;
    }

    protected viewChannel(id){
        this.saveViewModule(this.getMemoryViewModel());
        const idBrand = this.getVnAppZone().getApp().params.idBrand;

        page(`/brand/${idBrand}/categorization/channels/view/${id}`);
    }

    protected addChannel(){
        this.saveViewModule(this.getMemoryViewModel());
        const idBrand = this.getVnAppZone().getApp().params.idBrand;

        page(`/brand/${idBrand}/categorization/channels/add`);
    }
}



// WEBPACK FOOTER //
// ./js/modules/channels.ts